import { render, staticRenderFns } from "./EventsOverview.vue?vue&type=template&id=4b066c78&scoped=true"
import script from "./EventsOverview.vue?vue&type=script&lang=js"
export * from "./EventsOverview.vue?vue&type=script&lang=js"
import style0 from "./EventsOverview.vue?vue&type=style&index=0&id=4b066c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b066c78",
  null
  
)

export default component.exports